/**
 * Hyperliquid networks (testnet | mainnet): URLs and signing `source`. Pure data, no React and no browser APIs,
 * so the backend (`backend/`, #791) imports it too. `config/env.ts` re-exports everything here and adds the
 * React context; web code keeps importing from `config/env`.
 */
export type EnvName = 'testnet' | 'mainnet';

export interface EnvConfig {
  readonly name: EnvName;
  /** POST https://.../info */
  readonly infoUrl: string;
  /** POST https://.../exchange */
  readonly exchangeUrl: string;
  /** wss://.../ws */
  readonly wsUrl: string;
  /** L1-action phantom-agent source: "a" on mainnet, "b" on testnet. */
  readonly signingSource: 'a' | 'b';
  readonly isMainnet: boolean;
}

export const ENVIRONMENTS: Readonly<Record<EnvName, EnvConfig>> = Object.freeze({
  testnet: Object.freeze({
    name: 'testnet',
    infoUrl: 'https://api.hyperliquid-testnet.xyz/info',
    exchangeUrl: 'https://api.hyperliquid-testnet.xyz/exchange',
    wsUrl: 'wss://api.hyperliquid-testnet.xyz/ws',
    signingSource: 'b',
    isMainnet: false,
  }),
  mainnet: Object.freeze({
    name: 'mainnet',
    infoUrl: 'https://api.hyperliquid.xyz/info',
    exchangeUrl: 'https://api.hyperliquid.xyz/exchange',
    wsUrl: 'wss://api.hyperliquid.xyz/ws',
    signingSource: 'a',
    isMainnet: true,
  }),
});

export const DEFAULT_ENV: EnvName = 'testnet';
export const ENV_STORAGE_KEY = 'hip4.env';

export function isEnvName(v: unknown): v is EnvName {
  return v === 'testnet' || v === 'mainnet';
}

export function getEnvConfig(name: EnvName): EnvConfig {
  return ENVIRONMENTS[name];
}
